<template>
  <component :is="selection_sunday_results_component" />
</template>

<script>
import ContentSelectionSundayResultsDesktop from "@/components/Content/ContentSelectionSundayResultsDesktop";
import ContentSelectionSundayResultsMobile from "@/components/Content/ContentSelectionSundayResultsMobile";

export default {
  components: {
    ContentSelectionSundayResultsDesktop,
    ContentSelectionSundayResultsMobile
  },

  data: () => ({
    selection_sunday_results_component: null
  }),

  methods: {
    load_component_content() {
      this.selection_sunday_results_component = window.matchMedia(
        "(min-width:1025px)"
      ).matches
        ? "content-selection-sunday-results-desktop"
        : "content-selection-sunday-results-mobile";
    }
  },
  created() {
    this.load_component_content();
    window.addEventListener("resize", () => {
      this.load_component_content();
    });
  }
};
</script>

<style lang="scss">
.sidearm-mm-results {
  .fp-tableCell {
    position: relative;
    min-height: 100% !important;
    padding-top: $header-height;
  }
  .fp-slidesNav {
    display: none;
  }
}
@media (max-width: #{$breakpoint-x-large}) {
  .sidearm-mm-results {
    .fp-tableCell {
      padding-top: 0;
    }
  }
}
</style>
